export default {
    type: {
        TASK            : 'task',
        NOTE            : 'note',     // note is old for document
        USER            : 'user',
        LINK            : 'link',
        SWITCH_OPTIONS  : 'switch_options'
    },
}